import { useResponsive } from './layout'

function useWindowSize() {
  const { windowSize } = useResponsive()

  return windowSize
}

export default useWindowSize
